import { api } from '../api'

export const facebookServicesApi = api.injectEndpoints({

    endpoints: (builder) => ({
        getPixelById: builder.query({
            query: (pixelId) => `/ads-accounts/adspixels/${pixelId}/adspixel`,
            transformResponse: (response, meta, arg) => response.data,
        }),
        getPixelByAdaccountId: builder.query({
            query: (adsAccountId) => `/ads-accounts/pixels/${adsAccountId}`,
            transformResponse: (response, meta, arg) => response.data,
        }),
        createPixel: builder.mutation({
            query: ({ adsAccountId, payload }) => ({
                url: `/ads-accounts/${adsAccountId}/adspixels`,
                method: "POST",
                body: payload,
            }),
            transformResponse: (response, meta, arg) => response.data,
            transformErrorResponse: (response, meta, arg) => {
                const error = new Error(response.data.message);
                error.status = response.status;
                error.message = response.data.message;
                return error;
            },
        }),
        getFacebookPages: builder.query({
            query: (adsAccountId) => `/ads-accounts/pages/${adsAccountId}`,
            transformResponse: (response, meta, arg) => response.data,
        }),
        getInstagramAccounts: builder.query({
            query: (adsAccountId) => `/ads-accounts/instagrams/${adsAccountId}`,
            transformResponse: (response, meta, arg) => response.data,
        }),
        getGeoLocations: builder.query({
            query: ({ searchTerm, adsAccountId }) => ({
                url: `adsets/search?q=${searchTerm}&type=adgeolocation&limit=10&adsAccountId=${adsAccountId}`,
                method: 'POST',
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
        getLocationsForShopping: builder.query({
            query: ({ searchTerm, adsAccountId }) => ({
                url: `adsets/search?q=${searchTerm}&type=adgeolocation&limit=10&adsAccountId=${adsAccountId}&location_types=["country","region"]`,
                method: 'POST',
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
        getLocationMeta: builder.mutation({
            query: ({ payload }) => ({
                url: `/adsets/search`,
                method: "POST",
                body: payload
            }),
            transformResponse: (response, meta, arg) => response.data.data,
        }),
        getDetailedTargeting: builder.query({
            query: ({ searchTerm, adsAccountId }) => `adsets/targetingsearch/${adsAccountId}?q=${searchTerm}&limit=20`,
            transformResponse: (response, meta, arg) => response.data,
        }),
        getLocales: builder.query({
            query: ({ searchTerm, adsAccountId }) => ({
                url: `adsets/search?type=adlocale&q=${searchTerm}&adsAccountId=${adsAccountId}&limit=20`,
                method: 'POST',
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
        matchBulkLocations: builder.mutation({
            query: ({ locationType, matchPayload, adsAccountId }) => {
                let url_ = locationType === 'region' ?
                    `adsets/search?adsAccountId=${adsAccountId}&location_types=["region"]`
                    : `adsets/search?adsAccountId=${adsAccountId}&type=adgeolocationmeta`;

                return {
                    url: url_,
                    method: 'POST',
                    body: { ...matchPayload }
                }
            },
            transformResponse: (response, meta, arg) => response.data,
            transformErrorResponse: (response, meta, arg) => {
                const error = new Error(response.data.message);
                error.status = response.status;
                error.message = response.data.message;
                return error;
            },
        }),
        getTargetCustomAudience: builder.query({
            query: ({ searchTerm, adsAccountId }) => ({
                url: `adsets/search?type=customaudience&q=${searchTerm}&account_id=${adsAccountId}&limit=20`,
                method: 'POST',
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
        getExcludeLocations: builder.query({
            query: ({adsAccountId}) => `/adsets/${adsAccountId}/account_controls`,
            transformResponse: (response, meta, arg) => response.data,
        }),
        getTargetDevices: builder.query({
            query: ({ adsAccountId }) => ({
                url: `adsets/search?type=adTargetingCategory&class=user_device&account_id=${adsAccountId}`,
                method: 'POST',
            }),
            transformResponse: (response, meta, arg) => response.data,
        }),
    }),
});

export const {
    useGetPixelByAdaccountIdQuery,
    useGetPixelByIdQuery,
    useCreatePixelMutation,
    useGetFacebookPagesQuery,
    useGetInstagramAccountsQuery,
    useGetGeoLocationsQuery,
    useGetLocationsForShoppingQuery,
    useGetDetailedTargetingQuery,
    useGetLocalesQuery,
    useMatchBulkLocationsMutation,
    useGetLocationMetaMutation,
    useGetTargetCustomAudienceQuery,
    useGetExcludeLocationsQuery,
    useGetTargetDevicesQuery,
} = facebookServicesApi;
